import { Helmet } from 'react-helmet-async';
import { useLang } from '../i18n';

const META = {
  home: {
    path: '/',
    it: {
      title: 'PROPAQ | Piatti Pronti Gluten Free per HORECA e Private Label',
      desc: 'Produzioni alimentari gluten free a Guarda Veneta (RO): 84 referenze certificate per HORECA, hotellerie e private label. Pronte in 5 minuti, 100% italiane.',
    },
    en: {
      title: 'PROPAQ | Gluten-Free Ready Meals for HORECA & Private Label',
      desc: 'Gluten-free food production in Guarda Veneta (RO), Italy: 84 certified references for HORECA, hotels and private label. Ready in 5 minutes.',
    },
  },
  azienda: {
    path: '/azienda',
    it: {
      title: 'Lo Stabilimento PAQ | PROPAQ Produzione Alimentare Gluten Free',
      desc: 'Dentro lo stabilimento PAQ di Guarda Veneta (RO): cucina, abbattimento a -40°C e confezionamento in un processo accelerato di qualità, 100% senza glutine.',
    },
    en: {
      title: 'The PAQ Plant | PROPAQ Gluten-Free Food Production',
      desc: 'Inside the PAQ plant in Guarda Veneta (RO), Italy: kitchen, -40°C blast freezing and packaging in an accelerated quality process, 100% gluten free.',
    },
  },
  catalogo: {
    path: '/catalogo',
    it: {
      title: 'Catalogo Piatti Gluten Free B2B: 84 Referenze | PROPAQ',
      desc: 'Sfere di riso Kris, primi, secondi, contorni, sughi e dolci senza glutine per HORECA e private label. Registrati gratis e scarica il catalogo PDF.',
    },
    en: {
      title: 'Gluten-Free B2B Catalogue: 84 References | PROPAQ',
      desc: 'Kris rice balls, first courses, mains, sides, sauces and gluten-free desserts for HORECA and private label. Register free and download the PDF.',
    },
  },
  'private-label': {
    path: '/private-label',
    it: {
      title: 'Private Label Gluten Free per HORECA, Hotellerie e GDO | PROPAQ',
      desc: 'Produzione conto terzi di piatti pronti gluten free: ricette su misura, packaging dedicato e volumi flessibili per HORECA, hotellerie e retail.',
    },
    en: {
      title: 'Gluten-Free Private Label for HORECA, Hotels & Retail | PROPAQ',
      desc: 'Contract manufacturing of gluten-free ready meals: tailored recipes, dedicated packaging and flexible volumes for HORECA, hotels and retail.',
    },
  },
  contatti: {
    path: '/contatti',
    it: {
      title: 'Contatti | PROPAQ Produzione Alimentare Gluten Free — Guarda Veneta (RO)',
      desc: 'Contatta PROPAQ per listini HORECA, campionature e progetti private label gluten free. Stabilimento a Guarda Veneta (RO). Tel +39 0425 544695.',
    },
    en: {
      title: 'Contacts | PROPAQ Gluten-Free Food Production — Guarda Veneta (RO)',
      desc: 'Contact PROPAQ for HORECA price lists, samples and gluten-free private label projects. Plant in Guarda Veneta (RO), Italy. Tel +39 0425 544695.',
    },
  },
};

const SEO = ({ page }) => {
  const { lang } = useLang();
  const cfg = META[page];
  const m = cfg[lang];
  const origin = window.location.origin;
  const url = origin + cfg.path;
  const image = origin + '/images/og-cover.jpg';
  return (
    <Helmet>
      <html lang={lang} />
      <title>{m.title}</title>
      <meta name="description" content={m.desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="PROPAQ" />
      <meta property="og:title" content={m.title} />
      <meta property="og:description" content={m.desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content={lang === 'it' ? 'it_IT' : 'en_GB'} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={m.title} />
      <meta name="twitter:description" content={m.desc} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
